import React from 'react';
import { mapConfigs } from '../../config/mapConfigs';

interface MapVariableSelectorProps {
  selectedVariable: string;
  onVariableChange: (variableId: string) => void;
  disabled?: boolean;
}

const MapVariableSelector: React.FC<MapVariableSelectorProps> = ({
  selectedVariable,
  onVariableChange,
  disabled = false
}) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <label style={{ 
        fontSize: '14px', 
        fontWeight: '500', 
        color: '#333',
        whiteSpace: 'nowrap'
      }}>
        Map Variable:
      </label>
      <select
        id="map-variable-select"
        value={selectedVariable}
        onChange={(e) => onVariableChange(e.target.value)}
        disabled={disabled}
        style={{
          padding: '6px 12px',
          border: '1px solid #ccc',
          borderRadius: '4px',
          fontSize: '14px',
          backgroundColor: disabled ? '#f5f5f5' : 'white',
          color: disabled ? '#999' : '#333',
          cursor: disabled ? 'not-allowed' : 'pointer',
          minWidth: '180px'
        }}
      >
        {mapConfigs.map((config) => (
          <option key={config.id} value={config.id}>
            {config.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default MapVariableSelector;
